import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'underscore';

const statusConfig = {
  124: 'statusPaused_icon', // UserPaused
  126: 'statusPaused_icon', // BudgetPaused
  127: 'statusPaused_icon', // BudgetUserPaused
  123: 'statusDeleted_icon', // Deleted
  8: 'statusSuspended_icon', // Suspended
  121: 'statusEnabled_icon', // Active
};

/**
 * default selector item component
 * when the renderItem props was omitted, this default style will be used
 */
export class ItemComponent extends PureComponent {
  render() {
    return (
      <div className="item-content">
        <span className={classnames('statusIcon', _.result(statusConfig, this.props.item.status, 'statusEnabled_icon'))} />
        <span className="text" title={this.props.item.name}>
          {this.props.item.name}
        </span>
      </div>
    );
  }
}

ItemComponent.propTypes = {
  item: PropTypes.shape({
    status: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};
